import React from 'react'
import { P } from '../../styles/Elements'
import { DolaThemes } from '../../styles/types'
import { NumberIcon as StyledNumberIcon } from './styles'

interface NumberProps {
  active?: boolean
  n: number
  theme: DolaThemes
}

const NumberIcon: React.FC<NumberProps> = ({ n, active, theme }) => {
  return (
    <StyledNumberIcon dolaTheme={theme} mode={active ? 'active' : 'default'}>
      <P>{n}</P>
    </StyledNumberIcon>
  )
}

export default NumberIcon
